module.exports = __webpack_public_path__ + "static/media/logo.daaaba81.svg";